module.exports = __webpack_public_path__ + "img/symbol_6.a117b5ae.png";